<section class="py-24 bg-white dark:bg-shl-navy border-t border-gray-100 dark:border-gray-800">
  <div class="mx-auto max-w-7xl px-6 lg:px-8">
    <div class="text-center mb-16">
      <h2 class="text-3xl font-black text-shl-navy dark:text-white">{{ 'process.title' | translate }}</h2>
      <p class="mt-4 text-gray-500 dark:text-gray-300">{{ 'process.subtitle' | translate }}</p>
    </div>
    <div class="process-grid grid gap-8 md:grid-cols-4">
      <div class="process-step process-step--one group">
        <div class="process-step__content">
          <div class="process-step__top">
            <span class="process-step__badge">1</span>
            <div class="process-step__icon">
              <mat-icon fontSet="material-symbols-outlined" class="text-3xl">request_quote</mat-icon>
            </div>
          </div>
          <h3 class="process-step__title">{{ 'process.steps.request_quote.title' | translate }}</h3>
          <p class="process-step__desc">{{ 'process.steps.request_quote.description' | translate }}</p>
        </div>
        <div class="process-step__arrow" aria-hidden="true">
          <mat-icon fontSet="material-symbols-outlined">arrow_forward</mat-icon>
        </div>
      </div>
      <div class="process-step process-step--two group">
        <div class="process-step__content">
          <div class="process-step__top">
            <span class="process-step__badge">2</span>
            <div class="process-step__icon">
              <mat-icon fontSet="material-symbols-outlined" class="text-3xl">gavel</mat-icon>
            </div>
          </div>
          <h3 class="process-step__title">{{ 'process.steps.customs.title' | translate }}</h3>
          <p class="process-step__desc">{{ 'process.steps.customs.description' | translate }}</p>
        </div>
        <div class="process-step__arrow" aria-hidden="true">
          <mat-icon fontSet="material-symbols-outlined">arrow_forward</mat-icon>
        </div>
      </div>
      <div class="process-step process-step--three group">
        <div class="process-step__content">
          <div class="process-step__top">
            <span class="process-step__badge">3</span>
            <div class="process-step__icon">
              <mat-icon fontSet="material-symbols-outlined" class="text-3xl">local_shipping</mat-icon>
            </div>
          </div>
          <h3 class="process-step__title">{{ 'process.steps.transit.title' | translate }}</h3>
          <p class="process-step__desc">{{ 'process.steps.transit.description' | translate }}</p>
        </div>
        <div class="process-step__arrow" aria-hidden="true">
          <mat-icon fontSet="material-symbols-outlined">arrow_forward</mat-icon>
        </div>
      </div>
      <div class="process-step process-step--four group">
        <div class="process-step__content">
          <div class="process-step__top">
            <span class="process-step__badge">4</span>
            <div class="process-step__icon">
              <mat-icon fontSet="material-symbols-outlined" class="text-3xl">check_circle</mat-icon>
            </div>
          </div>
          <h3 class="process-step__title">{{ 'process.steps.delivery.title' | translate }}</h3>
          <p class="process-step__desc">{{ 'process.steps.delivery.description' | translate }}</p>
        </div>
        <div class="process-step__arrow" aria-hidden="true">
          <mat-icon fontSet="material-symbols-outlined">arrow_forward</mat-icon>
        </div>
      </div>
    </div>
  </div>
</section>
